'use client';

import { createContext, useContext, type ReactNode } from 'react';

import { resolvePhoneCountry } from '../lib/phone-country';
import { useTenantCurrency } from './currency-icon';

const TenantPhoneCountryContext = createContext<string | null | undefined>(undefined);

export function TenantPhoneCountryProvider({
  country,
  children,
}: {
  country?: string | null;
  children: ReactNode;
}) {
  return (
    <TenantPhoneCountryContext.Provider value={country}>
      {children}
    </TenantPhoneCountryContext.Provider>
  );
}

export function useTenantPhoneCountry() {
  const country = useContext(TenantPhoneCountryContext);
  const currency = useTenantCurrency();

  return resolvePhoneCountry(country, currency);
}
